export const documentFields = {
  // AIRA Document fields
  OfferNumber: `Número de oferta`,
  DeliveryTerms: `Términos de entrega`,
  OrderDate: `Fecha del pedidos`,
  OrderNumber: `Número de orden de compra`,
};
